export default __webpack_public_path__ + "static/media/Regular.bcbc19d8.eot";